(function() {
  // ===== Desktop hero video =====
  // Keep the existing hero image on phones and for visitors who prefer less motion.
  var heroVideo = document.querySelector('.cc-hero-video');
  var heroSource = heroVideo && heroVideo.querySelector('source[data-src]');
  var mobileHero = window.matchMedia('(max-width: 820px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function loadHeroVideo() {
    if (!heroVideo || !heroSource || heroSource.src || mobileHero.matches || reducedMotion.matches) return;
    heroSource.src = heroSource.getAttribute('data-src');
    heroVideo.load();
    var playback = heroVideo.play();
    if (playback && typeof playback.catch === 'function') playback.catch(function() {});
  }

  loadHeroVideo();
  if (mobileHero.addEventListener) mobileHero.addEventListener('change', loadHeroVideo);

  // ===== Camera finder tabs =====
  var tabs = Array.prototype.slice.call(document.querySelectorAll('.cc-cf-tab'));
  var panels = Array.prototype.slice.call(document.querySelectorAll('[data-cf-panel]'));
  if (tabs.length && panels.length) {
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var index = tab.getAttribute('data-cf-tab');
        tabs.forEach(function(t) {
          var active = t === tab;
          t.classList.toggle('cc-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        panels.forEach(function(p) {
          p.hidden = p.getAttribute('data-cf-panel') !== index;
        });
      });
    });
  }

  // ===== FAQ accordion (one open at a time) =====
  var faqItems = Array.prototype.slice.call(document.querySelectorAll('.cc-faq-item'));
  faqItems.forEach(function(item) {
    var btn = item.querySelector('[data-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('cc-is-open');
      faqItems.forEach(function(i) { i.classList.remove('cc-is-open'); });
      if (!isOpen) item.classList.add('cc-is-open');
    });
  });

  // ===== Exit-intent $50-off popup =====
  var overlay = document.getElementById('cc-exit-overlay');
  if (!overlay) return;
  var EXIT_SHOWN_KEY = 'cc-exit-shown';

  function showOverlay() {
    overlay.hidden = false;
  }
  function hideOverlay() {
    overlay.hidden = true;
  }

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) hideOverlay();
  });
  var closeBtn = overlay.querySelector('[data-cc-exit-close]');
  if (closeBtn) closeBtn.addEventListener('click', hideOverlay);

  if (overlay.dataset.ccForceOpen === 'true') {
    // The customer form on this page just posted successfully — show the
    // confirmation inside the modal even though the mouseout trigger never fired.
    sessionStorage.setItem(EXIT_SHOWN_KEY, '1');
    showOverlay();
    return;
  }

  var triggered = false;
  document.addEventListener('mouseout', function(e) {
    if (e.clientY < 6 && !triggered && !sessionStorage.getItem(EXIT_SHOWN_KEY)) {
      triggered = true;
      sessionStorage.setItem(EXIT_SHOWN_KEY, '1');
      showOverlay();
    }
  });
})();
